import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {CancellationList} from "./components/CancellationList";

export const Cancellation = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.cancellation')}`}
                         content={<CancellationList/>}/>
}